export const smallBreakpoint = 576;
export const mediumBreakpoint = 736;
export const largeBreakpoint = 980;
export const xxlBreakpoint = 1200;
